import { useEffect,useState } from "react";
import { BrowserRouter, Routes, Route,useNavigate } from "react-router";
import {userservices} from '../services/userServices';
import { Dropdown } from 'primereact/dropdown';
import { Progressspinner } from '../components/loaderComp';
import {Tablescom} from '../components/tablescomp';
import {Haspermision} from '../components/permissionscomponent';
const Users = () => {
    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const [selectedCity, setSelectedCity] = useState(null);
    const cities = [
        { name: 'New York', code: 'NY' },
        { name: 'Rome', code: 'RM' },
        { name: 'London', code: 'LDN' },
        { name: 'Istanbul', code: 'IST' },
        { name: 'Paris', code: 'PRS' }
    ];


    useEffect(()=>{
       getusers(); 
    },[]);

    const handleClick = () => {
        navigate('/adduser'); // Navigates to the About page
      };

    const getusers  = ()=> {
      setUserloaded(false);
      userservices.getusers().then((response)=>{
          if(response.status == 200){
              setUsers(response.data.data);
              setUserloaded(true);
          }else{
              setUsers([]);
              setUserloaded(true);
          }  
      }).catch((error)=>{
          setUsers([]);
          setUserloaded(true);
      }); 
    } 

    const [colDefs, setColDefs] = useState([
        { headerName: "Name",field: "name" },
        { headerName: "Email",field: "email" },
        { headerName: "Role",field: "role_name" },
        { headerName: "User Type",field: "usertype" },
        { headerName: "Status",field: "status",cellRenderer: (params) => {
            return (
                <span className={params.data.status === 'Active' ? "txt-success" : "txt-error"}>
                    {params.data.status}
                </span>
            );
          } },
        { headerName: "Action",
          cellRenderer: (params) => {
            return (
              <>
                  <Haspermision component={( <button className="btn btn-warning btn-sm" onClick={(e) => editredirect(params.data.id,params.data)}><i className="fa fa-edit cl-light"></i></button>)} permssion={'updateuser'}/>
                  &nbsp;
                  <Haspermision component={(<button className="btn btn-danger btn-sm"><i className="fa fa-trash"></i></button>)} permssion={'deleteuser'}/>
              </>
            );
          } }
      ]);
    
    
    const displayusers  = ()=> {
      let array_data = [];
      users.forEach((value)=>{
           array_data.push( <tr>
            <td>{value.name}</td>
            <td>{value.email}</td>
            <td>{value.role_name}</td>
            <td>{value.usertype}</td>
            <td><span className={value.status == 'Active' ? "txt-success" : "txt-error"}>{value.status}</span></td>
            <td>
              <Haspermision component={( <button className="btn btn-warning btn-sm" onClick={(e) => editredirect(value.id,value)}><i className="fa fa-edit cl-light"></i></button>)} permssion={'updateuser'}/>
             
              &nbsp;
              <Haspermision component={(<button className="btn btn-danger btn-sm"><i className="fa fa-trash"></i></button>)} permssion={'deleteuser'}/>
              
            </td>
          </tr>); 
      })

      return array_data;
    } 

    const editredirect = (id,Data) =>{
      navigate(`/edit-user/${id}`, { state: { user: Data } });
    }

    function filteruser(e){
        console.log(e.target.value);
        let val = e.target.value;
        setUserloaded(false);
        userservices.getusersfiltered({status:val}).then((response)=>{
             if(response.status == 200){
                setUsers(response.data.data);
                setUserloaded(true);
             }else{
                setUsers([]);
                setUserloaded(true);
             } 
        }).catch((error)=>{
          console.log(error);
          setUserloaded(true);
        });
    }

    return(
         <>
            
            <div className="row">
               <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div style={{display:'flex',justifyContent:'space-between'}}>
                      <span>
                       <select className="form-control" onChange={filteruser}>
                           <option value="active">Active users</option>
                           <option value="inactive">Inactive users</option>
                        </select>  
                      </span> 
                      <Haspermision component={(  <button className="btn btn-secondary btn-round pull-right" onClick={handleClick}>Add User</button>)} permssion={'adduser'}/>
                     
                     </div>
                  </div>
                </div>
              </div>
              
              <div className="col-md-12">
              {userloaded ? (<div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Users</h4>
                  </div>
                  <div className="card-body">
                    {/* <Tablescom rowdata={users} coldefs={colDefs} isloaded={null}/> */}
                     <div className="table-responsive"><table
                        id="basic-datatables"
                        className="display table table-striped table-hover"
                      >
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Email</th>  
                            <th>Roles</th>
                            <th>User Type</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                           {displayusers()}
                        </tbody>
                      </table></div> 
                  </div>
                </div>) : <Progressspinner/>}
              </div>
           </div>       
         </> 
    );    
}

export default Users;